<template>
  <el-dialog :title="type==='edit'?'编辑优惠码':'新增优惠码'" width="900px" :visible.sync="dialogFormVisible" :before-close="closeCategoryDialog">
    <el-form :model="form" ref="ruleForm" :rules="rules" label-position="right" label-width="120px">
      <el-form-item label="活动名称" prop="couponName">
        <el-input type="text" placeholder="请输入活动名称" v-model="form.couponName" maxlength="25" show-word-limit style="width:500px" />
      </el-form-item>
      <el-form-item label="优惠码" prop="couponCode">
        <el-input :disabled="type === 'edit'" type="text" placeholder="请输入优惠码" v-model="form.couponCode" maxlength="25" show-word-limit style="width:500px" />
        <el-checkbox v-if="form.discountRule!==3" :disabled="type === 'edit'" v-model="form.useInConjunction" style="margin-left:20px">与其他活动优惠叠加使用</el-checkbox>
      </el-form-item>
      <el-form-item label="活动时间" prop="endTime">
        <!-- <el-date-picker
          v-model="form.date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="newTime"
          :picker-options="{disabledDate}"
        >
        </el-date-picker> -->
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            placeholder="开始时间"
            style="margin-right: 14px"
            :picker-options="{disabledDate}"
            :disabled="type === 'edit'">
          </el-date-picker>
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="结束时间"
            :picker-options="{disabledDate: disabledDateOver}"
            @blur="endDate">
          </el-date-picker>
      </el-form-item>
      <el-form-item label="优惠类型" prop="discount">
        <el-select :disabled="type === 'edit'" v-model="form.discountRule" placeholder="请选择" style="width:120px" @change="form.discount = undefined">
          <el-option label="固定减价" :value="2"></el-option>
          <el-option label="折扣" :value="1"></el-option>
          <el-option label="注册推广码" :value="4"></el-option>
        </el-select>
        <el-input-number :disabled="type === 'edit'" v-model="form.discount" placeholder="请输入数字" :min="0" :max="form.discountRule===1?99:100000" controls-position="right" class="input-with-select" style="width:140px" />
        <span style="margin-left:10px">{{ form.discountRule === 1?'%OFF':'USD' }}</span>
      </el-form-item>
      <el-form-item label="优惠码数量" prop="couponNum">
        <el-input-number v-model="form.couponNum" placeholder="请输入数量" step-strictly :disabled="form.couponChecked" controls-position="right" :min="1" :max="100000" style="width:200px">张</el-input-number>
        <div>
          <el-checkbox v-model="form.couponChecked" @change="e =>handleChecked('couponNum', e)">不限</el-checkbox>
        </div>
      </el-form-item>
      <el-form-item v-if="form.discountRule!==4" label="每人限用" prop="perPerson">
        <el-input-number v-model="form.perPerson" placeholder="请输入数量" step-strictly :disabled="form.perChecked" controls-position="right" :min="1" :max="100000" style="width:200px">次</el-input-number>
        <div>
          <el-checkbox v-if="form.discountRule!==4" v-model="form.perChecked" @change="e =>handleChecked('perPerson', e)">不限</el-checkbox>
        </div>
      </el-form-item>
      <el-form-item  v-if="form.discountRule!==4" label="优惠门槛" prop="satisfy">
        <el-select :disabled="type === 'edit'" v-model="form.discountCondition" placeholder="请选择" style="width:120px" @change="form.satisfy = 0">
          <el-option label="无门槛" :value="0"></el-option>
          <el-option label="消费满件数" :value="1"></el-option>
          <el-option label="消费满金额" :value="2"></el-option>
        </el-select>
        <el-input-number v-model="form.satisfy" :disabled="form.discountCondition===0 || type === 'edit'" placeholder="请输入数字" :min="1" :max="100000" controls-position="right" class="input-with-select" style="width:140px" />
        <span style="margin-left:10px">{{ form.discountCondition === 1?'件':form.discountCondition === 2?'USD':'' }}</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeCategoryDialog">取 消</el-button>
      <el-button type="primary" @click="confirmDialogVisible">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import API from "@/api";
import moment from 'moment';
import _ from 'lodash'

const checkCode = (rule, value, callback) => {
  let regex=/^[0-9a-zA-Z]+$/
  if (!value) {
    return callback(new Error('请输入优惠码'));
  } else if (!regex.test(value)) {
    return callback(new Error('优惠码只能包含英文字母(含大小写)和数字'));
  } else callback()
}

const rules = {
  couponName: [
    { required: true, message: '请输入活动名称', trigger: 'blur' },
  ],
  couponCode: [
    { validator: checkCode, trigger: 'blur', required: true },
  ],
  date: [
    { required: true, message: '请选择日期', trigger: 'change' }
  ],
  endTime: [
    { required: true, message: '请选择日期', trigger: 'blur' }
  ],
  discount: [
    { required: true, message: '请输入数字', trigger: 'blur' },
  ],
  couponNum: [
    { required: true, message: '请输入数量', trigger: 'blur' },
  ],
  perPerson: [
    { required: true, message: '请输入数量', trigger: 'blur' },
  ],
  satisfy: [
    { required: true, message: '请输入数字', trigger: ['blur', 'change'] },
  ],
}

const form = {
  couponName: undefined,
  couponCode: undefined,
  useInConjunction: false,
  // date: [],
  startTime: undefined,
  endTime: undefined,
  discountRule: 2,
  discount: undefined,
  couponNum: undefined,
  couponChecked: false,
  perPerson: undefined,
  perChecked: false,
  discountCondition: 2,
  satisfy: undefined
}

export default {
  data() {
    return {
      dialogFormVisible: false,
      rules: rules,
      form: { ...form },
      type: '',
      originalData: {} // 编辑的原数据
    }
  },
  computed: {
    newTime() {
      return [moment().format('HH:mm:ss')]
    },
  },
  created() {
  },
  methods: {
    // disabledDate(date) {
    //   return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
    // },
    disabledDate(date) {
      if(this.form.endTime) {
        return date.getTime() > this.form.endTime || date.getTime() < Date.now() - 24 * 60 * 60 * 1000
      }
      return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
    },
    disabledDateOver(date) {
      if (this.type === 'edit') return date.getTime() < this.originalData.endTime
      else if(this.form.startTime) return date.getTime() < this.form.startTime
      else return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
    },
    show(row, type) {
      this.type = ''
      console.log(row)
      this.dialogFormVisible = true
      if (type === 'edit') {
        this.type = type
        this.originalData = _.cloneDeep(row)
        const _form = _.cloneDeep(row)
        this.form = {
          ..._form,
          // date: [moment(_form.startTime).format('YYYY-MM-DD HH:mm:ss'), moment(_form.endTime).format('YYYY-MM-DD HH:mm:ss')],
          discount: _form.discountRule === 1 ? _form.discountPercent : _form.discountRule === 4 ? _form.rechargeAmount : _form.discountFixed,
          couponNum: _form.couponCodeNum > 100000 ? 0 : _form.couponCodeNum,
          couponChecked: _form.couponCodeNum > 100000,
          perPerson: _form.perPersonNum > 100000 ? 0 : _form.perPersonNum,
          perChecked: _form.perPersonNum > 100000,
          satisfy: (_form.satisfyNum || _form.satisfyAmount) || 0
        }
      }
    },
    closeCategoryDialog() {
      this.dialogFormVisible = false
      this.form = { ...form }
      this.$refs.ruleForm.resetFields()
    },
    confirmDialogVisible() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.form.startTime) {
            this.$message.error('请选择开始时间!')
            return
          }
          const _form = { ...this.form }
          const param = {
            couponName: _form.couponName,
            couponCode: _form.couponCode,
            useInConjunction: _form.discountRule === 4 ? undefined : _form.useInConjunction,
            // startTime: moment(this.form.date[0]).valueOf(),
            // endTime: moment(this.form.date[1]).valueOf(),
            startTime: moment(this.form.startTime).valueOf(),
            endTime: moment(this.form.endTime).valueOf(),
            discountRule: _form.discountRule,
            couponCodeNum: _form.couponChecked ? 2147483647 :_form.couponNum,
            perPersonNum: _form.perChecked ? 2147483647 : _form.perPerson,
            discountCondition: _form.discountRule === 4 ? undefined : _form.discountCondition,
            createOngoingCoupon: Date.now() >= moment(this.form.startTime).valueOf() ? true : undefined
          }
          param[param.discountRule === 1 ? 'discountPercent' : _form.discountRule === 4 ? 'rechargeAmount' : 'discountFixed'] = _form.discount
          if (param.discountCondition !==0) param[param.discountCondition === 1 ? 'satisfyNum' : 'satisfyAmount'] = _form.satisfy

          if (this.type === 'edit') {
            param.id = this.form.id
            this.editCoupon(param)
            return
          }
          API.addCoupon(param).then(res => {
            if (res.code === 10000) {
              this.$message.success(res.message)
              this.closeCategoryDialog()
              this.$emit('addSuccess')
            } else this.$message.warning(res.message)
          }).catch((err) => {
            this.$message.error(err.data.message)
          })
        }
      })
    },
    endDate() {
      if (this.type === 'edit') {
        moment(this.form.endTime).valueOf() < this.originalData.endTime && (this.form.endTime = this.originalData.endTime )
      } else {
        moment(this.form.endTime).valueOf() <= moment(this.form.startTime).valueOf() && (this.form.endTime = moment(this.form.startTime).valueOf() + (1000*60*60) )
      }
    },
    // 编辑优惠券
    editCoupon(param) {
      API.editCoupon(param).then(res => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.closeCategoryDialog()
          this.$emit('addSuccess')
        } else this.$message.warning(res.message)
      })
    },
    handleChecked(type, e) {
      this.form[type] = e ? 0 : undefined
    },
  }
}
</script>

<style  lang="scss" scoped>
</style>